import { create } from 'zustand';

export type TimeRangePreset = 'today' | '7d' | '30d' | 'thisMonth' | 'custom';

export interface TimeRange {
  preset: TimeRangePreset;
  /** ISO date (YYYY-MM-DD), inclusive */
  from: string;
  /** ISO date (YYYY-MM-DD), inclusive */
  to: string;
}

interface TimeRangeState extends TimeRange {
  set: (range: TimeRange) => void;
  setPreset: (preset: TimeRangePreset, from: string, to: string) => void;
}

function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}

const initial: TimeRange = {
  preset: 'today',
  from: todayIso(),
  to: todayIso(),
};

/**
 * 사용자가 현재 보고 있는 시간 범위.
 *
 * Insights/Reports/Revenue/Statistics 차트가 공유. preset(상대) 또는 custom(절대 from/to).
 * 새로고침 시 today로 리셋되는 게 자연스럽다고 판단해 persist 미사용.
 */
export const useTimeRangeStore = create<TimeRangeState>()((set) => ({
  ...initial,
  set: (range) => set(range),
  setPreset: (preset, from, to) => set({ preset, from, to }),
}));
